var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgEducation = function SvgEducation(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "M19 11.917V17.5a1 1 0 0 1-.22.625C17.245 20.045 14.954 21 12 21c-2.953 0-5.244-.955-6.78-2.875A1 1 0 0 1 5 17.5v-5.583L.586 9.91c-.781-.355-.781-1.465 0-1.82L10.76 3.466a3 3 0 0 1 2.482 0L23.414 8.09c.781.355.781 1.465 0 1.82l-.914.416v4.556a1.5 1.5 0 1 1-2 0v-3.647l-1.5.682Zm-2 .909-3.759 1.708a3 3 0 0 1-2.482 0L7 12.826v4.306C8.128 18.374 9.769 19 12 19s3.872-.626 5-1.868v-4.306Zm-4.586-.113L20.584 9l-8.17-3.713a1 1 0 0 0-.828 0L3.416 9l8.17 3.713a1 1 0 0 0 .828 0Z"
  })));
};

export default SvgEducation;